/*
export const someMutation = (state) => {}
 */
import { initialState } from './state.js'
export default {
  isLoading,
  doneLoading,
  updateSelectedTab,
  setList,
  setCourseClassList,
  setCertificates,
  setManagers,
  setAffiliates,
  addCourse,
  updateCourseForm,
  updateCourseManagerPagination,
  updateCourseAffiliatePagination,
  updateSelectedManagers,
  updateSelectedAffiliates,
  setAutoCompleteList,
  setCourseForm,
  clearCourseForm,
  clearSelectedManagers,
  clearSelectedAffiliates,
  resetState
}

function isLoading (state) {
  state.loadingData = true
}

function doneLoading (state) {
  state.loadingData = false
}

function updateSelectedTab (state, selectedTab) {
  state.selectedTab = selectedTab
}

function setList (state, { courses }) {
  state.list = courses
}

function setCourseClassList (state, { classes }) {
  state.courseClassList = classes
}

function setCertificates (state, { certificates }) {
  state.managers = certificates
}

function setManagers (state, { managers }) {
  state.managers = managers
}

function setAffiliates (state, { affiliates }) {
  state.affiliates = affiliates
}

function updateCourseForm (state, { field, value }) {
  Object.assign(state.courseForm, {
    [field]: value
  })
}

function updateCourseManagerPagination (state, { field, value }) {
  Object.assign(state.courseManagerPagination, {
    [field]: value
  })
}

function updateCourseAffiliatePagination (state, { field, value }) {
  Object.assign(state.courseAffiliatePagination, {
    [field]: value
  })
}

function updateSelectedManagers (state, selectedManagers) {
  state.selectedManagers = [...selectedManagers]
}

function updateSelectedAffiliates (state, selectedAffiliates) {
  state.selectedAffiliates = [...selectedAffiliates]
}

function setAutoCompleteList (state, { courses }) {
  state.autoCompleteList = courses
}

function setCourseForm (state, { selectedCourse }) {
  for (let key in state.courseForm) {
    state.courseForm[key] = selectedCourse[key]
  }
}

function clearCourseForm (state) {
  for (let key in state.courseForm) {
    state.courseForm[key] = initialState.courseForm[key]
  }
}

function clearSelectedManagers (state) {
  state.selectedManagers = []
}

function clearSelectedAffiliates (state) {
  state.selectedAffiliates = []
}

function addCourse (state, { course }) {
  state.list.push(course)
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //   state[key] = initialState[key]
  // })
  state = { ...initialState }
}
